var swiper = new Swiper(".block_image-banners-slider", {
    slidesPerView: 3,
    spaceBetween: 20,
    pagination: {
      el: ".block_image-banners .swiper-pagination",
      clickable: true,
    },
   navigation: {
        nextEl: ".block_image-banners .block_slider-right-arrow",
        prevEl: ".block_image-banners .block_slider-left-arrow",
    },
    mousewheel: {
      forceToAxis: true,
  },
    breakpoints: { 
      320: {
        slidesPerView: 1,
        spaceBetween: 10     
      },    
      370: {
        slidesPerView: 1.3,
        spaceBetween: 10
      },  
      575: {
        slidesPerView: 2.4,
        spaceBetween: 10
      },
      1280: {
        slidesPerView:2.6   
      },           
      1599: {
        slidesPerView: 2.9
      }
    }
  });